(() => {
  if (/\/products\//.test(location.pathname)) return;
  const selector = '.ccs-sw,.cc-swatch,.cc-swatches button,.ccs-color-dot,.mova-hero__swatch,.mova-card__swatch,.tch-color-swatch,.tch-mug2-swatch,.all-cups-swatch,.pcfg__swatch,.color-swatch,.swatch';
  const colours = {beige:'#e8dcc4',black:'#1a1a1a',white:'#ffffff',blue:'#91bbd4',silver:'#c0c0c0','rose gold':'#b98279',brown:'#795548',gold:'#c9a34d',pistachio:'#b9c2a8',green:'#008000',purple:'#8b65a3',orange:'#ffa500',lilac:'#c2a4d4',pink:'#e7a5bb',red:'#ed161f',yellow:'#f1d65c',turquoise:'#6bb6a8',matcha:'#77915c',apricot:'#edb58e',lavender:'#b6a2ca',grenade:'#26374e',navy:'#26374e','navy blue':'#26374e',ivory:'#e8e1d3','light blue':'#91bbd4','baby blue':'#91bbd4'};
  function update(root) {
    const nodes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) nodes.unshift(root);
    for (const el of nodes) {
      if (el.hasAttribute('data-cc-square') || el.closest('.cc-home') || el.closest('[id^="MainProduct-"]') || document.body.classList.contains('template-product')) continue;
      const name = (el.dataset.value || el.dataset.colorName || el.dataset.colour || el.querySelector('input')?.value || el.querySelector('img')?.alt || el.title || el.getAttribute('aria-label') || '').trim();
      const key = name.toLowerCase().replace(/ \(sold out\)$/,'');
      const photo = el.matches('.ccs-sw,.cc-swatches button,.color-swatch');
      const chipColour = colours[key] || el.querySelector('.color-swatch__custom-color')?.style.getPropertyValue('--bg-color').trim();
      if (photo && !chipColour) continue;
      el.setAttribute('data-cc-square','');
      if (photo) {
        el.setAttribute('data-cc-colour-chip','');
        el.style.setProperty('--cc-chip-colour', chipColour);
      }
      if (name && !el.title) el.title = name;
    }
  }
  update(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) update(node);
  }).observe(document.body,{childList:true,subtree:true});
})();
